module.exports = __webpack_public_path__ + "img/blue_161.ba483c44.png";